import rainbetLogo from "@/assets/rainbet-logo.png";
import rainbetIcon from "@/assets/rainbet-sidebar-icon.png.asset.json";

export type Partner = {
  name: string;
  displayName: string;
  affiliateUrl: string;
  code: string;
  profileUrl: (username: string) => string | null;
  logo: string | null;
  icon: string | null;
};

export const PARTNER: Partner = {
  name: "Rainbet",
  displayName: "RAINBET",
  affiliateUrl: "https://rainbet.com/?r=gamducks",
  code: "GamDucks", // TODO: confirm with Rainbet
  // TODO: Rainbet public profile URL pattern unknown — returns null for now
  profileUrl: (_username: string) => null,
  logo: rainbetLogo,
  icon: rainbetIcon.url,
};
/** HypeDrop is a secondary affiliate partner (challenges, leaderboards, battles). */
export const HYPEDROP = {
  name: "HypeDrop",
  code: "GAMDUCKS",
  affiliateUrl: "https://hypedrop.com/r/GAMDUCKS",
} as const;

/**
 * Code-usage requirement per challenge platform. `null` = no code needed
 * (community challenges run on GamDucks itself).
 */
export const PLATFORM_CODE: Record<
  "rainbet" | "hypedrop" | "community",
  { name: string; code: string; url: string } | null
> = {
  rainbet: { name: PARTNER.name, code: PARTNER.code, url: PARTNER.affiliateUrl },
  hypedrop: { name: HYPEDROP.name, code: HYPEDROP.code, url: HYPEDROP.affiliateUrl },
  community: null,
};
